export interface IIgnoreMouseWheelDirective extends ng.IScope {
	ignoreMouseWheelDirective: IgnoreMouseWheelDirective;
}

export class IgnoreMouseWheelDirective implements ng.IDirective {
	public restrict = 'C';
	public require = 'ngModel';
	public $scope: IIgnoreMouseWheelDirective;

	public link = ($scope: IIgnoreMouseWheelDirective, element: any) => {
		$scope.ignoreMouseWheelDirective = this;
		this.$scope = $scope;

		$(() => {
			element.bind('mousewheel', function ( event ) {
				element.blur();
			} );
		});
	}
	
}

